import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import LogoPreview from "@/pages/LogoPreview";
import BlogIndex from "@/pages/BlogIndex";
import BlogArticle from "@/pages/BlogArticle";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      <div className="App font-body bg-ink text-white min-h-screen">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/logos" element={<LogoPreview />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" />
      </div>
    </LanguageProvider>
  );
}

export default App;
